<template>
  <modal v-if="app" v-model="showModal" height="auto" :name="name" @closed="handleClosed">
    <template #title>
      <span class="color_danger">Please be aware!</span>
    </template>
    <template #content>
      <p class="mb-3">
        <span>You are about to remove the application <span v-html="applicationName"/> from your account.</span>
        <br><br>
        All integrations and flows that are depending on this application will also be removed and no longer be shown on
        your dashboard.
      </p>
      <div class="mb-3">
        <div v-if="!loadingDependencyIntegrations">
          <p><span v-html="applicationName"/> is currently used by the following integrations:</p>
          <ul v-if="dependencyIntegrations.length" class="list-unstyled">
            <li v-for="dependencyIntegration in dependencyIntegrations" :key="dependencyIntegration">
              {{ dependencyIntegration }}
            </li>
          </ul>
          <span v-else>No integrations found.</span>
        </div>
        <loader theme="without-margin" v-else/>
      </div>
      <p class="mb-3">
        Please be aware that this action cannot be undone in any way and all information stored for the application,
        integration and flows will be lost. Billing for the above integrations will also be halted and after the end of
        the current billing cycle you will no longer be charged with the fees for running the integrations and flows
        using this application.
      </p>
      <p class="mb-3">
        Are you sure you want to remove the application <span v-html="applicationName"/>?
      </p>
    </template>
    <template #footer>
      <button class="button button_cancel" type="button" @click="handleCancel">Cancel</button>
      <button class="button button_danger" type="button" @click="handleDeleteApplication">Remove</button>
    </template>
  </modal>
</template>
<script>
import Swal from "sweetalert2";
import Modal from "@/components/Shared/Modal";
import LoadingView from "@/components/Shared/LoadingView.vue";
import Loader from "@/components/Shared/Loader.vue";

export default {
  name: 'DeleteModal',

  components: {
    Loader,
    LoadingView,
    Modal
  },

  emits: ['deleted-your-app', 'closed'],

  props: {
    name: String,

    user: Object,

    app: {
      type: [Object, null],
      default: null,
    },
  },

  data: () => ({
    showModal: false,
    loadingDependencyIntegrations: false,
    dependencyIntegrations: [],
  }),

  computed: {
    applicationName() {
      return `<strong>${this.app.name}</strong><code v-if="${this.app.alias}">${this.app.alias}</code>`
    }
  },

  watch: {
    showModal: async function (value) {
      if (value) {
        await this.prepareDependencyIntegrations()
      }
    },
  },

  methods: {
    async prepareDependencyIntegrations() {
      this.loadingDependencyIntegrations = true
      this.dependencyIntegrations = []

      await axios
        .get(`/user/${this.user.id}/application-info/${this.app.id}/dependency-integrations`)
        .then(({data}) => {
          this.dependencyIntegrations = data.data.dependencyIntegrations
        })

      this.loadingDependencyIntegrations = false
    },

    async handleDeleteApplication() {
      let applicationId = this.app.id

      axios
        .delete(`/user/${this.user.id}/application-remove/${applicationId}`)
        .then(() => {
          this.handleCancel()
          this.$emit('deleted-your-app', applicationId)

          Swal.fire({
            text: this.trans('dashboard.alerts.success_delete_application'),
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
          })
        });
    },

    handleClosed() {
      this.$emit('closed');
    },

    handleCancel() {
      this.$vfm.hide(this.name);
    },
  },
};
</script>
